<template>
  <DatePicker
    v-bind="$props"
    :class="{ 'has-focus': hasFocus }"
    v-on="listeners"
    v-focus="hasFocus"
  >
    <template #input>
      <DatePickerInput
        v-bind="$attrs"
        class="dp-input"
      />
    </template>
  </DatePicker>
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';
import DatePicker, { DatePickerInput } from '@ssi/vue-common/src/components/formControls/DatePicker';

export default {
  inheritAttrs: false,

  mixins: [focusable],

  components: {
    DatePicker,
    DatePickerInput
  },

  props: {
    ...DatePicker.props
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        invalid: () => this.$emit('invalid', new Error('must be a valid format'))
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.dp-input {
  border: none;
  padding: 0;
  outline: none;
  width: 100%;
}
</style>
